import UserStore from '../Stores/UserStore'

export enum CancelReason {
    Other = 500,
    CancelAddressProblem = 501,
    CancelPassportProblem = 502,
    CancelClientProblem = 503,
    CancelPhonesProblem = 504,

    CancelConfiscated = 100,
    CancelReopen = 101,

    CancelByStore = 1,
    CancelByClient = 2,
    CancelByExpert = 3,
    CancelByLogistics = 4,
}

export class CancelReasonEntity {

    static getDefaultByRole() {
        const us = UserStore.getInstance()

        if (us.checkCreditConsultant) {
            return CancelReason.CancelByClient
        }

        if (us.checkCreditExpert) {
            return CancelReason.CancelByExpert
        }

        if (us.checkLogisticsAgent) {
            return CancelReason.CancelByLogistics
        }

        return CancelReason.Other
    }

    static getBlockedReasonsByRole() {
        const us = UserStore.getInstance()

        if (us.checkCreditConsultant) {
            return [CancelReason.CancelByStore, CancelReason.CancelByExpert, CancelReason.CancelByLogistics]
        }

        if (us.checkLogisticsAgent) {
            return [
                CancelReason.Other,
                CancelReason.CancelAddressProblem,
                CancelReason.CancelPassportProblem,
                CancelReason.CancelClientProblem,
                CancelReason.CancelPhonesProblem,
                CancelReason.CancelConfiscated,
                CancelReason.CancelReopen,
                CancelReason.CancelByStore,
                CancelReason.CancelByClient,
                CancelReason.CancelByExpert]
        }

        return []
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/CancelReasonModel.ts